const map = {
	"./3MGulf.gif": 3189,
	"./ABC.png": 5678,
	"./ABJ.jpg": 1215,
	"./ABNAMRO.gif": 6715,
	"./ADBA.jpg": 9900,
	"./ADIDAS.gif": 9431,
	"./ADVANTECH.jpg": 4336,
	"./AGI.gif": 4036,
	"./AMD.png": 8336,
	"./AOYAMA.gif": 1227,
	"./ARAS.jpg": 2861,
	"./ATMEL.jpg": 9885,
	"./AVANTI.gif": 6286,
	"./Abest.jpg": 3033,
	"./BANGKOKBANK.jpg": 8419,
	"./BBL.jpg": 1450,
	"./BCA.png": 3700,
	"./BCCI.jpg": 3989,
	"./BENQ.jpg": 7960,
	"./BNPPARIBAS_APAC.png": 9422,
	"./BOBUAE.jpg": 4304,
	"./BONY.jpg": 8570,
	"./CAE.jpg": 539,
	"./CITIBANK.gif": 7792,
	"./CITYLINK.gif": 5422,
	"./CREATIVE.jpg": 5175,
	"./CXAIRWAY.gif": 3547,
	"./DADULUXE.jpg": 6020,
	"./DBS.png": 2447,
	"./DDKS.jpg": 1338,
	"./DEUBANK.jpg": 9886,
	"./ECLAT.jpg": 7513,
	"./EDOM.gif": 4104,
	"./EMERSON.jpg": 8311,
	"./EPCOS.gif": 4117,
	"./ESA.jpg": 7431,
	"./Exterian.jpg": 9536,
	"./F4F1.jpg": 2237,
	"./FAB.gif": 610,
	"./FAIRCHD.gif": 1712,
	"./Finisar.gif": 951,
	"./HITACHI.gif": 9379,
	"./HSBCBH.gif": 3283,
	"./ICICI.jpg": 8347,
	"./IIJS.jpg": 4579,
	"./INFINEON.gif": 6673,
	"./IPSOFT.gif": 9496,
	"./JHKI.jpg": 3862,
	"./JHKI2.jpg": 2990,
	"./LAM.gif": 2531,
	"./MATSUSHITA.gif": 706,
	"./MAYBANK.png": 1983,
	"./MINDRAY.png": 9230,
	"./MSMBVN.jpg": 7501,
	"./MyTest.gif": 4281,
	"./NANCO.gif": 9816,
	"./NATWDEXP.gif": 2986,
	"./NIKEiD.jpg": 5008,
	"./OnSemi.jpg": 5437,
	"./PACBRAND.gif": 6072,
	"./PERMATA.png": 6680,
	"./PIN.jpg": 779,
	"./Poslaju.gif": 769,
	"./RADIM_EXPERIMENT2_X.jpg": 9828,
	"./RBS.jpg": 6481,
	"./SABB.jpg": 6416,
	"./SBINRI.gif": 2654,
	"./SGSMC.jpg": 5255,
	"./SSCSSES.gif": 58,
	"./Solectro.gif": 7368,
	"./TCTMO.jpg": 3803,
	"./TDME.gif": 2025,
	"./TWTI.gif": 1621,
	"./UNEX.gif": 5825,
	"./UNIQLO.png": 116,
	"./UOB.gif": 9079,
	"./UOBTH.jpg": 8032,
	"./UOB_NEW.jpg": 1871,
	"./Vishay.gif": 6951,
	"./Vonage.gif": 5801,
	"./bsi.png": 2780,
	"./bsi_new.png": 7587,
	"./close-btn.png": 773,
	"./creditel.jpg": 6796,
	"./dell.gif": 2550,
	"./dhl.jpg": 8926,
	"./dhl_courier.jpg": 1962,
	"./dhl_plane.jpg": 8057,
	"./dhl_van.jpg": 9004,
	"./ems.jpg": 7443,
	"./ford.gif": 8936,
	"./gems.gif": 7655,
	"./gerber.gif": 4422,
	"./gm.gif": 7947,
	"./hangseng.gif": 6546,
	"./honeywell.gif": 9960,
	"./hp.gif": 655,
	"./hsbc.gif": 3421,
	"./intel.gif": 3321,
	"./lxml.gif": 5244,
	"./makalot.gif": 6138,
	"./maxtor.gif": 162,
	"./mcb.jpg": 176,
	"./mcgr802.gif": 3538,
	"./moduslink.gif": 7865,
	"./nanya.jpg": 1975,
	"./nortel.gif": 7031,
	"./rockwell.jpg": 8099,
	"./scb.gif": 9989,
	"./seados.gif": 7526,
	"./sharp.gif": 6393,
	"./siemens.gif": 6735,
	"./smt.gif": 9597,
	"./stmicro.gif": 5754,
	"./tchart.gif": 8215,
	"./wachovia.jpg": 3456
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2930;